import React from 'react'
import styles from './PlannerNudge.scss'
import { NoticeBar } from 'common/styleguide/NoticeBar'
import { useFormatMessage, commonVerbs, commonCTAs } from 'lib/localization'
import { currentURLWithQueryParams } from 'lib/utils'
import fetchJSON from 'lib/fetchJSON'
import { defineMessages } from 'react-intl'
import _ from 'lodash'

const messages = defineMessages({
  welcome: {
    id: 'PlannerNudge.welcome',
    defaultMessage: 'Welcome to the updated route planner!'
  },
  old: {
    id: 'PlannerNudge.old',
    defaultMessage: 'Take me to the old planner'
  }
})

export const PlannerNudge = ({ onRequestClose }) => {
  const fm = useFormatMessage()
  const optIn = () => {
    fetchJSON(`/experiments/21/opt_in.json`, {}, { method: 'POST' })
    onRequestClose()
  }

  return (
    <NoticeBar id='rp_nudge' className={styles.plannerNudgeContainer}>
      <div className={styles.plannerNudge}>
        <div />
        <div className={styles.centered}>
          <span>{fm(messages.welcome)}</span>
          <a target='_blank' href='/news/4742-route-planner-improvements-recap'>{fm(commonCTAs.learnMore)}</a>
          <a onClick={optIn}><strong>{_.capitalize(fm(commonVerbs.dismiss))}</strong></a>
        </div>
        <a href={currentURLWithQueryParams({ old: 1 })}>{fm(messages.old)}</a>
      </div>
    </NoticeBar>
  )
}
